// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1c3D_","right":"styles_right__1hfEk"};